var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.375 20.5C12.375 20.5 3 15.25 3 8.87501C3.00019 7.74826 3.39061 6.65635 4.10489 5.78493C4.81916 4.91351 5.8132 4.31636 6.91799 4.09501C8.02278 3.87367 9.17014 4.04179 10.165 4.57079C11.1598 5.09979 11.9408 5.95702 12.375 6.99673L12.375 6.99673C12.8092 5.95702 13.5902 5.09979 14.585 4.57079C15.5799 4.04179 16.7272 3.87367 17.832 4.09501C18.9368 4.31636 19.9308 4.91351 20.6451 5.78493C21.3594 6.65635 21.7498 7.74826 21.75 8.87501C21.75 15.25 12.375 20.5 12.375 20.5Z", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});